import { lazy, Suspense } from 'react';
import { Route, Switch } from 'react-router-dom';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import '@weareopenr/component-library/build/global.scss';
import { NotificationContext } from '@weareopenr/component-library';
import ScrollToTop from './components/ScrollToTop/ScrollToTop';
import { CircularProgress } from '@mui/material';
import { SpinnerContainer } from 'src/pages/Dashboard/Dashboard.styles';
import 'src/assets/theme/global.scss';
import { WorkOSAuthProvider } from '@weareopenr/authkit';
import { PostHogProvider } from '@posthog/react';
import { ConfigDefaults } from 'posthog-js';

const Welcome = lazy(() => import('src/pages/Welcome'));
const Layout = lazy(() => import('src/components/Layout/Layout'));

declare global {
  interface Window {
    Cypress: Cypress.Cypress;
  }
}

const ConditionalPostHogProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const POSTHOG_KEY = process.env.REACT_APP_POSTHOG_KEY;
  const POSTHOG_HOST = process.env.REACT_APP_POSTHOG_HOST;

  if (!POSTHOG_KEY || !POSTHOG_HOST) {
    return <>{children}</>;
  }

  const options = {
    api_host: POSTHOG_HOST,
    defaults: '2025-05-24' as ConfigDefaults,
  };

  return (
    <PostHogProvider apiKey={POSTHOG_KEY} options={options}>
      {children}
    </PostHogProvider>
  );
};

const App = () => {
  return (
    <ConditionalPostHogProvider>
      <WorkOSAuthProvider clientId={process.env.REACT_APP_WORKOS_CLIENT_ID}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <NotificationContext>
            <Suspense
              fallback={
                <SpinnerContainer>
                  <CircularProgress color="secondary" />
                </SpinnerContainer>
              }
            >
              <Switch>
                <Route exact path="/login" component={Welcome} />
                <Route path="/" component={Layout} />
              </Switch>
            </Suspense>
          </NotificationContext>
          <ScrollToTop />
        </LocalizationProvider>
      </WorkOSAuthProvider>
    </ConditionalPostHogProvider>
  );
};

export default App;
